<app-hero title="{{'deals_title'| translate}}" imageUrl="assets/images/deals/deals-banner.svg"
    [imageSettings]="{width: 750, height: 750}"></app-hero>

<app-info-block>
    <p><strong>{{'subtitle_one' | translate}}</strong> {{'subtitle_two' | translate}}</p>
    <p>{{'text_info' | translate}}</p>
</app-info-block>

<app-info-block titleBlock="{{'question_info' | translate}}">
    <p><a routerLink="/my/login" class="rs-link">{{'text_info_p_one_button' | translate}}</a>{{'text_info_p_one' |
        translate}}</p>
    <p>{{'text_info_p_two' | translate}}</p>
    <p>{{'text_info_p_three' | translate}}</p>
    <p>{{'text_info_p_four' | translate}}</p>
    <p [innerHTML]="'text_info_p_five' | translate"></p>
</app-info-block>

<app-flyer-saldo backgroundImage="../../assets/landing-social-proof/flyer1.svg">
    <div class="container-flyer">
        <h2 class="title-flyer">{{'flyer_title_one' | translate}}<br>{{'flyer_title_two' | translate}}
            <br>
            <span>{{'flyer_title_three' | translate}}</span>
        </h2>
    </div>
</app-flyer-saldo>

<app-systems-feature [showDeals]="viewDeals" class="lazyload-user-social"></app-systems-feature>

